import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "./motion";
import { Sparkles } from "lucide-react";

const faqs = [
  {
    q: "O Talos é um chatbot genérico plugado por fora?",
    a: "Não. O Talos é o assistente inteligente nativo do MUFT ERP, construído diretamente sobre o banco de dados da sua conta. Ele consulta caixa, estoque, emissões fiscais, CRM e ponto na hora e devolve a resposta em português — sem você precisar abrir dezenas de relatórios. Em ações críticas como sangria, cancelamentos ou alterações em lote, ele solicita sua confirmação.",
  },
  {
    q: "Realmente não pago nada a mais por usuário adicional?",
    a: "Exatamente! Todos os planos do MUFT possuem usuários, funcionários, vendedores, produtos e clientes 100% ilimitados. Você pode cadastrar toda a sua equipe sem nenhum acréscimo na mensalidade. A única diferença entre os planos é a quantidade de filiais da sua empresa.",
  },
  {
    q: "Como funciona a integração oficial com o WhatsApp Business?",
    a: "A MUFT é um Provedor de Tecnologia Meta oficial. Isso significa que você conecta o WhatsApp da sua empresa em 1 clique através da API Cloud oficial da Meta, sem necessidade de QR Code instável, emuladores ou risco de bloqueio de chip. Você pode disparar ofertas, cobrar clientes via Pix e manter o histórico de atendimento 100% integrado ao CRM e ao PDV.",
  },
  {
    q: "Como funciona a emissão de NF-e e NFC-e no MUFT?",
    a: "O módulo fiscal cobre NF-e (modelo 55) e NFC-e (modelo 65) para Simples Nacional ou Regime Normal, gestão de certificado digital A1, consulta de status da SEFAZ em tempo real e exportação de XMLs em lote pro contador. Se uma nota é rejeitada, o Talos traduz o motivo técnico e sugere o ajuste exato.",
  },
  {
    q: "O Ponto Digital está em conformidade com a legislação do MTP?",
    a: "Sim. Foi desenvolvido estritamente de acordo com as exigências da Portaria 671 do Ministério do Trabalho. Conta com selfie + biometria facial, geolocalização com cerca virtual, espelho de ponto consolidado e banco de horas automático.",
  },
  {
    q: "Como o cadastro de produto por foto funciona?",
    a: "Você aponta a câmera para o código de barras ou fotografa o produto. O Talos lê o EAN, reconhece o item e sugere nome, marca, categoria e todo o enquadramento fiscal (NCM, CEST, CFOP, ICMS, PIS, COFINS, IBS/CBS) baseado no seu regime e estado. Sem conexão? O formulário continua em modo manual.",
  },
  {
    q: "Como funciona o modelo de contratação e cancelamento?",
    a: "Trabalhamos com assinaturas mensais transparentes, sem contratos de fidelidade ou multas rescisórias. Você pode alterar seu plano ou cancelar a qualquer momento. O cadastro é simples, rápido e você pode começar a usar imediatamente.",
  },
  {
    q: "O MUFT funciona sem internet?",
    a: "Sim. O PDV Frente de Caixa opera normalmente em modo offline e sincroniza todas as vendas assim que a conexão é restabelecida. Os módulos de retaguarda operam em nuvem com alta disponibilidade.",
  },
];

export const FAQ = () => (
  <section
    id="faq"
    className="bg-white py-24 transition-colors duration-500 dark:bg-navy-950 md:py-32"
    data-testid="faq-section"
  >
    <div className="mx-auto max-w-3xl px-6 md:px-12">
      <Reveal className="mb-14 text-center">
        <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-navy-100 bg-lavender/40 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.25em] text-navy-800 dark:border-white/10 dark:bg-navy-800 dark:text-lavender">
          <Sparkles className="h-3.5 w-3.5" /> Dúvidas Frequentes
        </div>
        <h2 className="text-4xl font-black tracking-tight text-navy-800 dark:text-white md:text-5xl">
          Tudo o que você precisa saber sobre o MUFT
        </h2>
      </Reveal>

      <Reveal>
        <Accordion type="single" collapsible className="w-full space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="rounded-2xl border border-navy-100 bg-ice/60 px-6 py-2 transition-colors dark:border-white/10 dark:bg-navy-900/60"
            >
              <AccordionTrigger className="text-left text-base font-bold text-navy-800 hover:no-underline dark:text-white">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pt-2 pb-4 text-sm font-medium leading-relaxed text-navy-400 dark:text-navy-100/70">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

export default FAQ;
